<template>
  <div id="datepicker-component">
    <div class="form-group">
      <label v-if="label !== ''" :for="name">
        {{ label }}
        <span v-if="mandatory" class="text-danger"> * </span>
      </label>
        <a
          v-if="tooltipMessage"
          v-b-tooltip.hover.top="tooltipMessage"
          href="javascript:void(0)"
        >
          <font-awesome-icon
            class="mx-1"
            :icon="`fa-solid fa-exclamation-circle`"
          />
        </a>

      <br v-if="label !== ''" />
      <Datepicker
        v-model="localValue"
        :id="`${name}-${index || ''}`"
        :name="name"
        input-class-name="custom-datepicker"
        :placeholder="placeholder"
        :teleport="true"
        format="dd/MM/yyyy"
        :size="size"
        :disabled="isDisable"
        position="left"
        hide-input-icon
        auto-apply
        @update:modelValue="onDateChange"
        @closed="setValue"
      ></Datepicker>
      <!-- display error messages -->
      <error-message-new
        v-if="!$hasField({ name, errors, index, parent }) && showError"
        :index="index"
        :errors="errors"
        :fieldName="name"
        :parent="parent"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  components: {
    Datepicker,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    tooltipMessage: {
      type: String,
      default: null
    },
    name: {
      type: String,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "sm",
    },
    modelValue: {
      type: [String, Date],
      default: null,
    },
    isDisable: {
      type: Boolean,
      default: null,
    },
    parent: {
      type: String,
      default: null,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: [Array],
      default: () => [],
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    localValue: null,
  }),
  watch: {
      modelValue: {
        handler(val) {
          if (val === null) {
            this.localValue = null;
          } else if (typeof val === "string" && !isNaN(Date.parse(val))) {
            this.localValue = new Date(val);
          } else if (val instanceof Date) {
            this.localValue = val;
          } else {
            this.localValue = null;
          }
        },
        immediate: true,
        deep: true,
      },
  },
  computed: {
    disabledState() {
      if (this.isDisable !== null) {
        return this.isDisable;
      }

      return this.handleFieldState({
        field: this.name,
        stateType: 'disable',
        logic: this.logic,
      });
    },
    errorState() {
      return (this.$hasField({
        name: this.name,
        errors: this.errors,
        index: this.index,
        parent: this.parent,
      }) && this.showError) === false
        ? "mx-input error-state"
        : "mx-input";
    },
  },
  methods: {
    $hasField,
    handleFieldState,
    setValue() {
      this.$emit("input", (this.localValue && this.localValue.getTime() !== 0) ? this.localValue : null); // For v-model compatibility
      this.$emit("changeEvent", this.name, this.index);
    },
    onDateChange(val) {
      this.localValue = (val && val.getTime() !== 0) ? val : null;
      this.$emit("input", this.localValue); // For v-model compatibility
      this.$emit("changeEvent", this.name, this.index);
    },
  },
};
</script>

<style lang="scss">
@import "@/style/typography.scss";
.custom-datepicker {
  height: 31px;
  font-size: 14px !important;
}
.normal-border {
  border-color: #ced4da;
}
</style>
